import { CountryCode } from '@carsys/enums/country-code'
import { SvgIcon } from '@mui/material'

export interface CCProp {
  country: CountryCode
}

/**
 * MoneyBillIcon will render the icon with a currency symbol.
 * It's used for as icon for invoices and other money related things
 */
const MoneyBillIcon: React.FC<CCProp> = ({ country }) => {
  return (
    <SvgIcon>
      <MoneyBillSVG country={country} />
    </SvgIcon>
  )
}

const MoneyBillSVG: React.FC<CCProp> = ({ country }) => {
  /* There's no 'bill' yet, just a currancy symbol */
  return (
    <svg>
      <CountryCodeToCurrency country={country} />
    </svg>
  )
}

const CountryCodeToCurrency: React.FC<CCProp> = ({ country }) => {
  switch (country) {
    case CountryCode.CF:
      return <CHFSVG />
    case CountryCode.US:
      return <USDSVG />
    case CountryCode.GB:
    case 'UK' as any:
      return <GBPSVG />
    case CountryCode.PL:
      return <PLNSVG />
  }

  return <EURSVG />
}

const EURSVG = () => {
  return (
    <path
      color='CurrentColor'
      strokeWidth='1'
      // eslint-disable-next-line max-len
      d='M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15l1-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15l1-2H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3l-1 2h4.06c-.04.33-.06.66-.06 1s.02.67.06 1H3l-1 2h4.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z'
    />
  )
}

const GBPSVG = () => {
  return (
    <path
      color='CurrentColor'
      strokeWidth='1'
      // eslint-disable-next-line max-len
      d='M14 21c1.93 0 3.62-1.17 4-3l-1.75-.88C16 18.21 15.33 19 14 19H9.1c.83-1 1.5-2.34 1.5-4 0-.35-.03-.69-.08-1H14v-2H9.82C9 10.42 8 9.6 8 8c0-1.93 1.57-3.5 3.5-3.5 1.5 0 2.79.95 3.28 2.28L16.63 6c-.8-2.05-2.79-3.5-5.13-3.5C8.46 2.5 6 4.96 6 8c0 1.78.79 2.9 1.49 4H6v2h2.47c.08.31.13.64.13 1 0 2.7-2.6 4-2.6 4v2h8z'
    />
  )
}
const USDSVG = () => {
  return (
    <path
      color='CurrentColor'
      strokeWidth='1'
      // eslint-disable-next-line max-len
      d='M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z'
    />
  )
}

const CHFSVG = () => {
  return <path stroke='CurrentColor' strokeWidth='1' d='M18 5V3H7v13H5v2h2v3h2v-3h4v-2H9v-3h8v-2H9V5z' />
}

const PLNSVG = () => {
  return (
    <text x='0' y='18' fill='CurrentColor' fontSize={16} fontWeight='bold'>
      zł
    </text>
  )
}

export default MoneyBillIcon
